import React, { useState, useMemo, useEffect, useCallback } from 'react'
import Card from 'react-bootstrap/Card';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify'
import Input from '../../Components/Form/Input';
import FormCustom from '../../Components/Form/FormCustom';
import Button from 'react-bootstrap/Button'
import Select from '../../Components/Form/Select';
import Radio from '../../Components/Form/Radio';

const ReporteVentas = _ => {
    const [isProcessing, setIsProccesing] = useState(false)
    const [rows, setRows] = useState([])
    const [data, setData] = useState({
        p_date_start: '',
        p_date_end: '',
        p_id_period: '',
        p_id_branch_office: ''
    })
    const [branchOffices, setBranchOffices] = useState([])
    const [reporte, setReport] = useState({})
    const [type, setType] = useState(1);
    const [period, setPeriod] = useState([])

    useEffect(() => {
        Controllers.worker.get_worker_branch_office_public().then(res => {
            setBranchOffices([
                ...res.data
            ])
        })
    }, [])

    useEffect(() => {
        Controllers.period.get_period().then(res => {
            setPeriod(res.data)
        })
    }, [])

    const loadRows = _ => {
        setIsProccesing(true)
        Controllers.document.reporte_ventas(data).then(res => {
            setRows(res.data.data)
            setReport({
                excel: res.data.excel.file,
                filename: res.data.excel.filename,
            })
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setIsProccesing(false)
            })
    }

    const branchOffice = useCallback(() => {
        if (!data.p_id_branch_office) {
            return ''
        }

        let findBranchOffice = branchOffices.find(w => parseInt(w.id_branch_office) === parseInt(data.p_id_branch_office))

        if (!findBranchOffice) {
            return ''
        }

        return {
            label: findBranchOffice.name_branch_office,
            value: findBranchOffice.id_branch_office
        }
    }, [data.p_id_branch_office, branchOffices])

    const cboPeriod = useCallback(() => {
        if (!data.p_id_period) {
            return ''
        }

        let findPeriod = period.find(w => parseInt(w.id_period) === parseInt(data.p_id_period))

        if (!findPeriod) {
            return ''
        }

        return {
            label: findPeriod.name_period,
            value: findPeriod.id_period
        }
    }, [data.p_id_period, period])

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                { name: 'id_document', text: 'ID Venta', align: 'center' },
                { name: 'id_customers', text: 'ID Cliente', align: 'center' },
                { name: 'full_name_customers', text: 'Cliente', align: 'center' },
                { name: 'date_doc', text: 'Fecha', align: 'center' },
                { name: 'name_branch_office', text: 'Sucursal', align: 'center' },
                { name: 'name_product', text: 'Nombre', align: 'center' },
                { name: 'key_product', text: 'Clave', align: 'center' },
                { name: 'price_unit', text: 'Precio Unitario', align: 'center' },
                { name: 'qty', text: 'Cantidad', align: 'center' },
                { name: 'iva_value', text: 'IVA %', align: 'center' },
                { name: 'subtotal', text: 'Subtotal', align: 'center' },
                { name: 'iva', text: 'IVA', align: 'center' },
                { name: 'total', text: 'Total', align: 'center' },
            ],
        ]}
        rows={rows}
        pageLength={100}
        isProcessing={isProcessing}
    />, [rows, isProcessing])

    return <>
        <Card>
            <Card.Header className="justify-content-between">
                <span>Reporte de Ventas</span>
            </Card.Header>
            <Card.Body>
                <FormCustom viewSubmit={false} onSubmit={_ => {
                    if (!data.p_id_branch_office) {
                        Helpers.toast.construct({
                            response: 'warning',
                            message: 'Seleccione una sucursal',
                            toast
                        })
                        return false;
                    }

                    if (type === 2 && !data.p_id_period) {
                        Helpers.toast.construct({
                            response: 'warning',
                            message: 'Seleccione una sucursal',
                            toast
                        })
                        return false;
                    }
                    loadRows()
                }}>
                    <Select
                        classNameParent="col-12 mb-2"
                        icon="fa fa-building"
                        text="Sucursal"
                        required
                        onChange={e => {
                            setReport({})
                            setData({ ...data, p_id_branch_office: e.value })
                        }}
                        value={branchOffice()}
                        options={branchOffices.map(w => {
                            return {
                                label: w.name_branch_office,
                                value: w.id_branch_office
                            }
                        })}
                    />
                    <div className="col-12">
                        <div className="d-flex">
                            <Radio
                                id="rdb-fechas"
                                classNameParent="mr-3 mb-2"
                                text="Fechas"
                                checked={type === 1}
                                onChange={e => {
                                    setData({
                                        ...data,
                                        p_id_period: ''
                                    })
                                    setType(1)
                                }}
                            />
                            <Radio
                                id="rdb-periodo"
                                classNameParent=""
                                text="Periodo"
                                checked={type === 2}
                                onChange={e => setType(2)}
                            />
                        </div>
                    </div>
                    {type === 1 && <>
                        <Input
                            classNameParent="col-6 mb-2"
                            type="date"
                            icon="far fa-calendar-alt"
                            placeholder="Fecha Inicio"
                            text="Fecha Inicio"
                            required
                            value={data.p_date_start}
                            onChange={e => {
                                setData({ ...data, p_date_start: e.currentTarget.value })
                            }}
                        />
                        <Input
                            classNameParent="col-6 mb-2"
                            type="date"
                            icon="far fa-calendar-alt"
                            placeholder="Fecha Fin"
                            text="Fecha Fin"
                            required
                            value={data.p_date_end}
                            onChange={e => {
                                setData({ ...data, p_date_end: e.currentTarget.value })
                            }}
                        />
                    </>}
                    {type === 2 && <Select
                        text="Periódo"
                        classNameParent="col-12 mb-2"
                        options={period.map(p => {
                            return {
                                label: p.name_period,
                                value: p.id_period
                            }
                        })}
                        value={cboPeriod()}
                        onChange={e => setData({
                            ...data,
                            p_id_period: e.value
                        })}
                    />}
                    <div className="col-4 mb-2">
                        <Button type="submit" size="sm">
                            <i className="fa fa-search"></i> Buscar
                        </Button>
                    </div>
                </FormCustom>
                {reporte?.filename ? <div className='mb-4'>
                    <a href={reporte?.excel} download={reporte?.filename}>
                        <Button size="sm" variant="success">
                            <i className="fa fa-file-excel mr-2"></i>Descargar Reporte Excel
                        </Button>
                    </a>
                </div> : ''}
                {dtRows}
            </Card.Body>
        </Card>
    </>
}

export default ReporteVentas